(function (app, ng) {
    app.component("requirementsComponent",
        {
            templateUrl: "App.Portal/States/MyBusiness/Components/Requirements/Requirements.template.html",
            controller: 'requirementsController',
            bindings: {
                policyDetails: "=",
                isModal: "<",
                viewUpdates: "=",
            }
        })
        .controller('requirementsController',
            ["_", "$filter", "$mdDialog", "newBusinessReportsApi", "$q", "reportsApi", "figToaster",
                function (_, $filter, $mdDialog, newBusinessReportsApi, $q, reportsApi, figToaster) {
                    var $ctrl = this;

                    ng.extend($ctrl, {
                        ui: {
                            loading: false,
                            notes: '',
                            isUploading: false
                        },
                        arcUserFilter: { IsExternalUser: false },
                        agentFilter: { IsExternalUser: true },
                        uploadingFiles: [],
                        removeFile: removeFile,
                        resolveRequirement: resolveRequirement,
                        textTruncate: textTruncate,
                        today: new Date(),
                        uploadFiles: uploadFiles
                    });

                    function uploadFiles(files, invalidFiles) {
                        if ($ctrl.uploadForm.$invalid) {
                            var invalidFileNames = _.map(invalidFiles,
                                function (file) {
                                    return file.name;
                                }).join(", ");
                            var toastClass = 'is-error';
                            var toastMessage;
                            //Added custom system feedback based on form validation
                            if ($ctrl.uploadForm.$error.maxSize) {
                                toastMessage = 'File size cannot exceed 30MB per file. Please upload a different file.';
                            }
                            if ($ctrl.uploadForm.$error.pattern) {
                                toastMessage = 'File type is not supported. Please upload a different file.';
                            }
                            figToaster.showSimple(invalidFileNames + ' not uploaded. ' + toastMessage, "top", toastClass);
                        }

                        if (files.length > 0 && $ctrl.uploadForm.$valid) {
                            //Add each valid file to filesList for uploading onSubmit
                            files.forEach(function (file) {
                                $ctrl.uploadingFiles.push(file);
                            });
                        }
                    }

                    function sendNotesOnlyToArc() {
                        $ctrl.ui.isUploading = true;
                        var message = "", toastClass = "";
                        $ctrl.ui.isUploading = false;
                        reportsApi.postPolicyTaskNotes($ctrl.policyDetails.CaseStatus.TaskId, $ctrl.ui.notes)
                            .then(function (response) {
                                message = "Note submitted succesfully!"
                                toastClass = "is-success";
                                $ctrl.policyDetails.CaseStatus.Notes.push(response);
                                var agentNote = ng.extend(response, {
                                    Type: 'Note',
                                    CreatedOn: $ctrl.today.toISOString(),
                                });
                                $ctrl.policyDetails.AgentResponses.unshift(agentNote);
                            })
                            .catch(function (error) {
                                message = "Error: something went wrong";
                                toastClass = "is-error";
                            })
                            .finally(function () {
                                if (toastClass === "is-success") {
                                    $ctrl.uploadingFiles = [];
                                    $ctrl.ui.notes = '';
                                }
                                $ctrl.ui.isUploading = false;
                                return figToaster.showSimple(message, "top", toastClass);
                            })
                    }

                    function sendFilesAndNotesToArc() {
                        var formData = new FormData();
                        $ctrl.ui.isUploading = true;
                        $ctrl.uploadingFiles.forEach(function (file) {
                            formData.append($ctrl.ui.notes, file, file.name);
                        });
                        var message = "", toastClass = "";

                        newBusinessReportsApi.postPolicyFiles($ctrl.policyDetails.PolicyGuid, formData)
                            .then(function (fileCount) {
                                message = fileCount === 1 ? "1 file uploaded successfully!" : fileCount + " files uploaded successfully!";
                                toastClass = "is-success";

                                var agentFiles = $ctrl.uploadingFile.map(function (file) {
                                    return ng.extend(file, {
                                        Type: 'File',
                                        CreatedOn: $ctrl.today.toISOString(),
                                    });
                                });
                                agentFiles.forEach(function (file) {
                                    $ctrl.policyDetails.AgentResponses.unshift(file);
                                });

                            })
                            .catch(function (error) {
                                message = "Error: something went wrong";
                                toastClass = "is-error";
                            })
                            .finally(function () {
                                if (toastClass === "is-success") {
                                    $ctrl.uploadingFiles = [];
                                    $ctrl.ui.notes = '';
                                }
                                $ctrl.ui.isUploading = false;
                                return figToaster.showSimple(message, "top", toastClass);
                            });
                    }

                    function resolveRequirement() {
                        if ($ctrl.uploadingFiles.length > 0)
                            sendFilesAndNotesToArc();
                        else if (!!$ctrl.ui.notes) {
                            sendNotesOnlyToArc()
                        }
                    }

                    function removeFile(file) {
                        //remove files from upload list before converting to formData
                        $ctrl.uploadingFiles = _.remove($ctrl.uploadingFiles, function (activeFile) {
                            return activeFile !== file;
                        });
                    }

                    function textTruncate(fullString, length, ending) {
                        var newString = ng.copy(fullString);
                        if (length === null) {
                            length = 50;
                        }
                        if (ending === null) {
                            ending = '...';
                        }
                        var strLength = !!newString ? newString.length : 0;
                        if (strLength > length) {
                            return newString.substring(0, length - ending.length) + ending;
                        } else {
                            return newString;
                        }
                    }

                    $ctrl.closeDialog = function (event) {
                        $mdDialog.hide(event);
                    }

                    $ctrl.$onInit = function () {
                        if (!!$ctrl.policyDetails.PolicyGuid) {
                            $ctrl.ui.loading = false;
                            const promises = [];
                            if ($ctrl.policyDetails.IsVariable) {
                                promises.push(newBusinessReportsApi.getVariablePolicyCaseStatusLatestByGuid($ctrl.policyDetails.PolicyGuid));
                            } else {
                                promises.push(newBusinessReportsApi.getPolicyCaseStatusLatestByGuid($ctrl.policyDetails.PolicyGuid));
                            }

                            promises.push(newBusinessReportsApi.getAgentUploadsByGuid($ctrl.policyDetails.PolicyGuid));
                            $q.all(promises)
                                .then(function (responses) {
                                    $ctrl.policyDetails.CaseStatus = responses[0];

                                    var agentNotes = $filter('filter')(responses[0].Notes, { IsExternalUser: true }).map(function (note) { return ng.extend(note, { Type: 'Note' }) });
                                    var agentUploads = responses[1].map(function (file) { return ng.extend(file, { Type: 'File' }) });
                                    $ctrl.policyDetails.AgentResponses = agentNotes.concat(agentUploads);

                                })
                                .catch(function (error) {
                                    console.log(error.data)
                                })
                                .finally(function () {
                                    $ctrl.ui.loading = false;
                                });
                        }
                    }
                }
            ]);
})(window.app, window.angular); //jshint ignore:line